import React, { useEffect, useState, useRef } from "react";
import ApiService, { initialAuthState } from "../Services/ApiServices";
import { useParams, useNavigate, Link } from "react-router-dom";
import { IoMdArrowDropright } from "react-icons/io";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import ProductReviewForm from "../ProductReviewForm/ProductReviewForm";
import jsPDF from "jspdf";
import "./OrderItemDetails.css";
import Navbar from "../New_Templates/Navbar";
import toast, { Toaster } from "react-hot-toast";
import html2canvas from "html2canvas";
import InvoicePrintable from "./InvoicePrintable";
import OrderTimeline from "../New_Templates/OrderTimeline/OrderTimeline";
import { TbReplaceFilled } from "react-icons/tb";
import RefundDetailsCard from "../New_Templates/RefundDetailsCard/RefundDetailsCard";
import { FiAlertTriangle, FiCheckCircle, FiLock } from "react-icons/fi";
import { createSlug } from "../../utils/slugify";

const OrderItemStatus = {
  PLACED: "placed",
  ORDERED: "confirmed",
  PACKED: "packed",
  SHIPPED: "shipped",
  OUT_FOR_DELIVERY: "out_for_delivery",
  DELIVERED: "delivered",
  CANCELLED: "cancelled",
  CONFIRMED: "confirmed",

  REPLACEMENT_REQUESTED: "replacement_requested",
  REPLACEMENT_APPROVED: "replacement_approved",
  REPLACEMENT_REJECTED: "replacement_rejected",
  PICKUP_SCHEDULED: "pickup_scheduled",
  PICKED_UP: "picked_up",
  REPLACEMENT_IN_PROGRESS: "replacement_in_progress",
  REPLACED: "replaced",
};

const RefundStatus = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
  SUCCESS: "success",
};

const formatDate = (dateStr) =>
  new Date(dateStr).toLocaleDateString("en-IN", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

const OrderItemDetails = () => {
  // const { orderId, deviceId } = useParams();
  const { orderId, slug } = useParams();
  const numericOrderId = Number(orderId?.split("-").pop());

  const deviceId = Number(slug?.split("-").pop());
  const [item, setItem] = useState(null);
  const [device, setDevice] = useState(null);
  const [order, setOrder] = useState(null);
  const [refundDevices, setRefundDevices] = useState([]);
  const [cancelReason, setCancelReason] = useState("");
  const [replaceReason, setReplaceReason] = useState("");
  const [replaceDescription, setReplaceDescription] = useState("");
  const [uploadedImage, setUploadedImage] = useState(null);
  const [showCancelReason, setShowCancelReason] = useState(false);
  const [showReplaceForm, setShowReplaceForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showReviewForm, setShowReviewForm] = useState(false);
  const [reviews, setReviews] = useState([]);
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [replacementQty, setReplacementQty] = useState(1);

  const [replacement, setReplacement] = useState(null);

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewUrls, setPreviewUrls] = useState([]);

  const companyCode = initialAuthState.companyCode;
  const unitCode = initialAuthState.unitCode;

  const navigate = useNavigate();


  const invoiceRef = useRef();

  const items = [
    {
      name: item?.name || "Product",
      description: item?.deviceId || "",
      qty: Number(item?.qty ?? 1),
      rate: Number(
        item?.rate ??
        item?.price ??
        Math.round((order?.totalAmount || 0) / (item?.qty || 1)),
      ),
      hsn: item?.hsn || "85269190",
      cgstPercent: 9,
      sgstPercent: 9,
    },
  ];

  const subtotal = items.reduce((s, it) => s + it.rate * it.qty, 0);
  const totalCgst = items.reduce(
    (s, it) => s + it.rate * it.qty * (it.cgstPercent / 100),
    0,
  );
  const totalSgst = items.reduce(
    (s, it) => s + it.rate * it.qty * (it.sgstPercent / 100),
    0,
  );
  const totalAmount = subtotal + totalCgst + totalSgst;
  const totals = {
    subtotal,
    totalCgst,
    totalSgst,
    totalAmount,
    amountInWords: "",
  };
  const specialPrice =
    Number(item?.device?.amount) -
    (Number(item?.device?.amount) * Number(item?.discountAmount)) / 100;

  console.log(item, item?.finalPrice, "item")

  const couponDiscountedAmount = item?.couponDiscount * 1.18;
  const round = (n) => Math.round(n * 100) / 100

  // const totalTax=item?.
  const finalItemSubtotal = round(item?.finalPrice * 1.18 * item?.quantity);

  const unitPrice = (num) => (round(num * 1.18 * 100) / 100).toFixed(2);
  const discountedPrice = (num) =>
    (round(num * 1.18 * 100) / 100).toFixed(2);

  const company = {
    name: "SHARON TELEMATICS PRIVATE LIMITED",
    addressLines: [
      "Company ID: CIN3333333333",
      "21-27, Double road",
      "Viman Nagar, Kakani Nagar",
      "Visakhapatnam",
      "Andhra Pradesh  Pincode : 530009",
    ],
    gstin: "37ABACS4415R1ZV",
  };

  const fetchOrders = async () => {
    try {
      const response = await ApiService.post(
        "order/getClientOrderById",
        { orderId: numericOrderId },
        { withCredentials: true },
      );

      if (response.status) {
        const orders = response.data;
        const currentOrder = orders;

        if (currentOrder) {

          const currentItem = currentOrder.items.find(
            (i) => Number(i.id) === Number(deviceId),
          );

          const currentDevice = Array.isArray(currentOrder.deviceDetails)
            ? currentOrder.deviceDetails.find(
              (d) => d.deviceId === currentItem?.device?.id,
            )
            : null;

          if (currentItem) {
            setItem(currentItem || null);

            // ✅ NEW: set latest replacement request
            if (currentItem.replacementRequests?.length > 0) {
              const latestReplacement =
                currentItem.replacementRequests[
                currentItem.replacementRequests.length - 1
                ];

              setReplacement(latestReplacement);
            }

            // const itemRefunds = response.data.refunds?.filter(
            //   (r) => r.orderItem?.id === currentItem.id
            // ) || [];

            // setRefundDevices(itemRefunds);
          }

          setOrder(currentOrder);
          setItem(currentItem || null);
          setDevice(currentDevice || null);
        }

        setRefundDevices(response?.data?.refunds || []);
      }
    } catch (error) {
      console.error("Error fetching order item details:", error);
      toast.error("Failed to load order details");
    }
  };


  useEffect(() => {
    fetchOrders();
  }, []);

  useEffect(() => {
    if (item) {
      fetchReviews();
    }
  }, [item]);

  const fetchReviews = async () => {
    const value = item?.device.id;
    try {
      const response = await ApiService.post(
        "/review/getReviewByDeviceAndClient",
        {
          companyCode,
          unitCode,
          deviceId: value,
        },
        { withCredentials: true },
      );

      if (response.status) {
        // const allReviews = response.data?.review || [];
        // const filteredReviews = allReviews.filter(
        //   (item) => item.deviceId.id === value
        // );

        setReviews(response?.data);
        setRating(response?.data?.rating || 0);
      }
    } catch (error) {
      console.error("Reviews fetching failed:", error);
    }
  };

  const handleStarClick = async (value) => {
    setRating(value);
    try {
      const payload = {
        companyCode,
        unitCode,
        // clientId: clientDbId,
        orderId: numericOrderId,
        deviceId: item.device.id,
        rating: value,
      };

      if (reviews && reviews.id) {
        payload.id = reviews.id;
      }

      const response = await ApiService.post(
        "/review/handleWebReviewDetails",
        payload,
      );

      toast.success("Rating submitted successfully!");
    } catch (error) {
      console.error("Rating submission failed:", error);
      toast.error("Failed to submit rating");
    }
  };

  // const handleDownloadInvoice = async () => {
  //   const invoiceEl = invoiceRef.current;
  //   if (!invoiceEl) return;

  //   const imgs = invoiceEl.getElementsByTagName("img");
  //   await Promise.all(
  //     Array.from(imgs).map((img) => {
  //       return new Promise((resolve) => {
  //         if (img.complete) {
  //           resolve();
  //         } else {
  //           img.onload = resolve;
  //           img.onerror = () => resolve();
  //         }
  //       });
  //     })
  //   );

  //   await new Promise((r) => setTimeout(r, 150));

  //   // CAPTURE WITH html2canvas
  //   const canvas = await html2canvas(invoiceEl, {
  //     scale: 2,
  //     useCORS: true,
  //     backgroundColor: "#ffffff",
  //   });

  //   const imgData = canvas.toDataURL("image/png");

  //   const pdf = new jsPDF("p", "mm", "a4");
  //   const imgProps = pdf.getImageProperties(imgData);

  //   const pdfWidth = 210;
  //   const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

  //   pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
  //   pdf.save(`Invoice_${order?.id || Date.now()}.pdf`);

  //   toast.success("Invoice downloaded!");
  // };

  const handleDownloadInvoice = (url) => {
    if (!url) {
      alert("Invoice not available yet");
      return;
    }

    window.open(url, "_blank"); // opens PDF
  };

  // const handleImageUpload = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     if (file.size > 5 * 1024 * 1024) {
  //       toast.error("Image size should be less than 5MB");
  //       return;
  //     }
  //     setUploadedImage(file);
  //     toast.success("Image uploaded successfully");
  //   }
  // };

  const refund = refundDevices?.find(
    (r) => r.orderItem?.id.toString() === item?.id.toString(),
  );

  console.log(refund, "refund details")
  console.log(refundDevices, "refundDevices")

  const refundStatus = refund?.refundStatus;

  const getRefundStatusMessage = (status) => {
    switch (status) {
      case "pending":
        return "Your replacement request is pending. We'll update you shortly.";
      case "request_recived":
        return "We've received your replacement request and are reviewing it.";
      case "request_accept":
        return "Your replacement request has been accepted.";
      case "request_reject":
        return "Unfortunately, your replacement request has been rejected.";
      case "pick_scheduled":
        return "Pickup for the item has been scheduled.";
      case "item_picked_up":
        return "The item has been picked up successfully.";
      case "new_item_dispatched":
        return "The replacement item has been dispatched.";
      case "replaced_sucess":
        return "The replacement was successful. Thank you!";
      case "returning":
        return "The item is being returned. We'll notify you once it's received.";
      default:
        return "Status unknown. Please contact support.";
    }
  };

  // const handleUpdate = async (actionType, additionalData = {}) => {
  //   setIsLoading(true);

  //   const basePayload = {
  //     companyCode,
  //     unitCode,
  //     clientId: clientDbId,
  //     deliveryAddressId: order.deliveryAddress?.id,
  //     buildingAddressId: order.buildingAddress?.id,
  //     ...additionalData,
  //   };

  //   try {
  //     if (actionType === "cancel") {
  //       const payload = {
  //         ...basePayload,
  //         id: orderId,
  //         OrderItemStatus: OrderItemStatus.CANCELLED,
  //         description: cancelReason || "User action",
  //       };

  //       const cancelResponse = await ApiService.post(
  //         "/order/UpdateOrder",
  //         payload
  //       );

  //       if (cancelResponse.status) {
  //         toast.success("Order item canceled successfully.");
  //         setTimeout(() => {
  //           // navigate(-1);
  //           navigate("/my-profile?tab=orders");
  //         }, 1500);
  //       } else {
  //         toast.error("Failed to cancel item.");
  //       }
  //     }
  //   } catch (err) {
  //     console.error("Error during order update:", err);
  //     toast.error("Something went wrong. Please try again.");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleUpdate = async (actionType, additionalData = {}) => {
    setIsLoading(true);

    try {
      if (actionType === "cancel") {
        const payload = {
          id: item.id,
          companyCode,
          unitCode,
          status: "cancelled",
          reason: cancelReason,
        };

        const response = await ApiService.post(
          "/order-item/updateStatus",
          payload,
        );

        if (response.status) {
          toast.success("Item cancelled. Refund initiated 💰");

          navigate("/my-profile?tab=orders");
        } else {
          toast.error(response.message || "Cancel failed");
        }
      }
    } catch (err) {
      toast.error(err?.data?.message || "Something went wrong");
      navigate("/my-profile?tab=orders");
    } finally {
      setIsLoading(false);
    }
  };

  if (!item || !order) {
    return (
      <div>
        {/* <Navbar /> */}
        <div className="order-item-loading">
          <div className="loading-spinner"></div>
          <p>Loading order details...</p>
        </div>
      </div>
    );
  }

  const deliveryDate = new Date(order.delivaryDate);
  const today = new Date();
  const status = item.itemStatus;

  const isDelivered = status === OrderItemStatus.Delivered;
  const isPacked = status === OrderItemStatus.Delivered;
  const isDispatched = status === OrderItemStatus.Dispatched;
  const isPending = status === OrderItemStatus.PENDING;
  const isConfirmed = status === OrderItemStatus.CONFIRMED;
  const isSuccess = status === OrderItemStatus.ORDERSUCESS;
  const isCancelled = status === OrderItemStatus.CANCELED;
  const isReturnRequested = status === OrderItemStatus.request_raised;
  const isReturnApproved = status === OrderItemStatus.request_approved;
  const isReturnRejected = status === OrderItemStatus.request_reject;
  const isReturnSuccess = status === OrderItemStatus.request_sucess;

  const CANCEL_ALLOWED_STATUSES = [
    "pending",
    // "confirmed",
    "placed",
    // "packed",
  ];

  const BLOCKED_STATUSES = [
    "cancelled",
    "delivered",
    "return_requested",
    "return_approved",
    "return_rejected",
    "return_success",
    "dispatched",
    "shipment_created",
    "packed",
  ];

  const canCancel =
    CANCEL_ALLOWED_STATUSES.includes(item.itemStatus) &&
    !BLOCKED_STATUSES.includes(item.itemStatus);

  const availableReplacementQty = Number(item?.availableReplacementQty || 0);
  const requestedReplacementQty = Number(replacement?.requestedQuantity || 0);
  const approvedReplacementQty = Number(replacement?.approvedQuantity || 0);
  const orderedQty = Number(item?.quantity || 0);
  const remainingReplacementQty = Number(item?.availableReplacementQty || 0);

  const canReplace =
    item?.canRequestReplacement === true &&
    availableReplacementQty > 0;

  // const canReplace =
  //   item.itemStatus === OrderItemStatus.DELIVERED &&
  //   !item.isReplacement &&
  //   ![
  //     OrderItemStatus.REPLACEMENT_REQUESTED,
  //     OrderItemStatus.REPLACEMENT_APPROVED,
  //     OrderItemStatus.REPLACEMENT_IN_PROGRESS,
  //     OrderItemStatus.REPLACED,
  //   ].includes(item.itemStatus);

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);

    setSelectedFiles(files);

    // preview
    const previews = files.map((file) => URL.createObjectURL(file));
    setPreviewUrls(previews);
  };

  const handleReplacementRequest = async () => {
    if (!replaceReason) {
      toast.error("Please select reason");
      return;
    }


    if (!replacementQty || replacementQty < 1) {
      toast.error("Please select replacement quantity");
      return;
    }

    if (replacementQty > availableReplacementQty) {
      toast.error(`Only ${availableReplacementQty} item(s) available for replacement`);
      return;
    }

    setIsLoading(true);

    try {

      const formData = new FormData();

      formData.append("orderItemId", item.id);
      formData.append("requestedQuantity", replacementQty);
      formData.append("reason", replaceReason);
      formData.append("comment", replaceDescription || "");

      // ✅ append files correctly
      selectedFiles.forEach((file) => {
        formData.append("files", file);
      });

      const response = await ApiService.post("/replacements", formData);

      if (response.status) {
        toast.success("Replacement request submitted");
        setShowReplaceForm(false);

        // setItem({
        //   ...item,
        //   itemStatus: OrderItemStatus.REPLACEMENT_REQUESTED,
        // });

        // reset
        setSelectedFiles([]);
        setPreviewUrls([]);
        setReplaceReason("");
        setReplaceDescription("");
        setReplacementQty(1);

        await fetchOrders();
      } else {
        toast.error("Failed to request replacement");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const getReplacementMessage = (status) => {
    switch (status) {
      case "requested":
        return "🟡 Replacement requested. Waiting for approval.";

      case "approved":
        return "🔵 Approved. Pickup will be scheduled.";

      case "rejected":
        return "🔴 Replacement rejected by admin.";

      case "pickup_scheduled":
        return "🟣 Pickup scheduled.";

      case "picked_up":
        return "📦 Item picked up.";

      case "replaced":
        return "✅ Replacement completed.";

      default:
        return "Processing...";
    }
  };

  const getCancellationPreview = () => {
    if (!item || !order) return null;

    const SHIPPING_CHARGE = 250;
    const FREE_SHIPPING_MIN_AMOUNT = 3000;
    const FREE_SHIPPING_MIN_QTY = 1;

    const round2 = (value) => Number(Number(value || 0).toFixed(2));

    const itemTotal = round2(item.totalPrice);
    const coupon = round2(item.couponShare || item.couponDiscount);
    const allocatedGatewayFee = round2(item.allocatedGatewayFee);
    const allocatedGatewayTax = round2(item.allocatedGatewayTax);

    const allItems = order.items || [];

    const activeItems = allItems.filter((i) => i.itemStatus !== "cancelled");

    const baseShippingCharge = round2(
      order.shippingCharge ||
      order.shippingAmount ||
      order.deliveryCharge ||
      order.summary?.shippingCharge ||
      SHIPPING_CHARGE
    );

    const shippingDiscountAmount = round2(
      order.shippingDiscountAmount ||
      order.shippingDiscount ||
      order.deliveryDiscount ||
      order.summary?.shippingDiscountAmount ||
      order.summary?.shippingDiscount ||
      order.summary?.deliveryDiscount ||
      0
    );

    const originalActiveQty = activeItems.reduce(
      (sum, i) => sum + Number(i.quantity || 0),
      0
    );

    const originalItemsAmount = round2(
      activeItems.reduce((sum, i) => sum + Number(i.totalPrice || 0), 0)
    );

    const originalFreeShippingEligible =
      originalItemsAmount >= FREE_SHIPPING_MIN_AMOUNT &&
      originalActiveQty >= FREE_SHIPPING_MIN_QTY;

    const originalShippingPaid = originalFreeShippingEligible
      ? 0
      : round2(Math.max(baseShippingCharge - shippingDiscountAmount, 0));

    const shippingWasCharged = originalShippingPaid > 0;

    const remainingItems = activeItems.filter((i) => i.id !== item.id);

    const remainingQty = remainingItems.reduce(
      (sum, i) => sum + Number(i.quantity || 0),
      0
    );

    const remainingAmount = round2(
      remainingItems.reduce((sum, i) => sum + Number(i.totalPrice || 0), 0)
    );

    const refunds = order.refunds || [];

    const alreadyRecoveredShipping = round2(
      refunds.reduce(
        (sum, refund) => sum + Number(refund.shippingDeduction || 0),
        0
      )
    );

    const remainingRecoverableShipping = round2(
      Math.max(baseShippingCharge - alreadyRecoveredShipping, 0)
    );

    const hasShipment = (item.shipmentItems || []).length > 0;

    const hasAnyShipmentInOrder = allItems.some(
      (i) => (i.shipmentItems || []).length > 0
    );

    const isLastItem = remainingItems.length === 0;

    const freeShippingEligible =
      remainingAmount >= FREE_SHIPPING_MIN_AMOUNT &&
      remainingQty >= FREE_SHIPPING_MIN_QTY;

    let type = "success";
    let title = "Cancellation Summary";
    let message = "";

    let shippingDeduction = 0;
    let shippingRefund = 0;
    let gatewayDeduction = allocatedGatewayFee;
    let refundAmount = 0;

    if (hasShipment) {
      type = "locked";
      title = "Cancellation Restricted";
      message = "This item is already shipped and cannot be cancelled.";
      refundAmount = 0;
    } else if (hasAnyShipmentInOrder) {
      type = "warning";
      title = "Shipping Charges Non-Refundable";
      message =
        "Some items in this order are already shipped. Shipping charges will not be refunded.";

      refundAmount = Math.max(itemTotal - gatewayDeduction, 0);
    } else if (isLastItem) {
      type = "warning";
      title = "Final Item Cancellation";
      message = "This is the final item cancellation. Your order will be fully closed.";

      shippingRefund = shippingWasCharged ? originalShippingPaid : 0;

      refundAmount = Math.max(itemTotal + shippingRefund - gatewayDeduction, 0);
    } else if (!freeShippingEligible) {
      type = "warning";
      title = "Shipping Charges Applied";

      shippingDeduction = shippingWasCharged ? 0 : remainingRecoverableShipping;

      message =
        shippingDeduction > 0
          ? "After cancellation, your remaining order no longer qualifies for free shipping."
          : "Shipping charges were already applied or adjusted previously.";

      refundAmount = Math.max(itemTotal - shippingDeduction - gatewayDeduction, 0);
    } else {
      type = "success";
      title = "Full Refund Available";
      message = "Free shipping remains active for your remaining order.";

      refundAmount = Math.max(itemTotal - gatewayDeduction, 0);
    }

    return {
      type,
      title,
      message,
      isLastItem,
      hasShipment,
      hasAnyShipmentInOrder,
      freeShippingEligible,
      itemTotal,
      coupon,
      originalShippingPaid,
      shippingWasCharged,
      shippingDeduction: round2(shippingDeduction),
      shippingRefund: round2(shippingRefund),
      gatewayDeduction: round2(gatewayDeduction),
      gatewayTaxDeduction: allocatedGatewayTax,
      refundAmount: round2(refundAmount),
      alreadyRecoveredShipping,
      remainingRecoverableShipping,
      remainingQty,
      remainingAmount,
    };
  };

  const getIcon = (type) => {
    switch (type) {
      case "success":
        return "#22c55e";
      case "locked":
        return "#ef4444";
      default:
        return "#f59e0b";
    }
  };

  const handleDownload = async (url, index) => {
    try {
      const response = await fetch(url, { mode: "cors" });
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `replacement-image-${index + 1}.jpg`;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);

      // fallback
      window.open(url, "_blank");
    }
  };

  const invoiceUrl =
    item?.shipmentItems?.[0]?.shipment?.invoice?.pdfUrl;

  return (
    <div>
      {/* <Navbar /> */}
      <Toaster position="top-right" />
      <div
        style={{
          position: "absolute",
          top: "-2000px",
          left: "0",
          opacity: 0,
          pointerEvents: "none",
        }}
      >
        <InvoicePrintable
          ref={invoiceRef}
          order={{
            id: order?.id,
            orderDateStr: formatDate(order?.orderDate),
            placeOfSupply: "Andhra Pradesh",
            deliveryAddress: order?.deliveryAddress,
          }}
          items={items}
          company={company}
          totals={totals}
        />
      </div>

      <div className="OrderItemDetails-container">
        <div className="OrderItemDetails-main">
          <div className="OrderItemDetails-left">
            <div className="order-item-header">
              {item.isReplacement && (
                <span className="badge badge-replacement">
                  <TbReplaceFilled /> Replacement
                </span>
              )}

              <div className="order-item-details-meta">
                <div className="order-item-details-meta-row">
                  <span className="order-item-details-meta-label">
                    Order ID:
                  </span>
                  <span className="order-item-details-meta-value">
                    {order.orderNumber}
                  </span>
                </div>

                <div className="order-item-details-meta-row">
                  <span className="order-item-details-meta-label">
                    Item ID:
                  </span>
                  <span className="order-item-details-meta-value">
                    {item.orderItemNumber}
                  </span>
                </div>
              </div>
            </div>

            <div className="OrderItemDetails-product">

              <div className="OrderItemDetails-productDetails">
                <h2
                  onClick={() => {
                    const slug = createSlug(item.device.name || item.device.webProductName);
                    navigate(`/products/${slug}`)
                  }}
                  className="OrderItemDetails-title"
                >
                  {item.device.name}
                </h2>

                <div className="OrderItemDetails-specs">
                  {item.isRelaySelected && item.relayAmount > 0 && (
                    <span className="OrderItemDetails-item-config-badge">
                      ⚡ {item?.isRelaySelected ? "Relay Included" : "No Relay"}
                    </span>
                  )}

                  {(item.networkType || item.networkAmount > 0) && (
                    <span className="OrderItemDetails-item-config-badge">
                      📶 {item.networkType || "Network not selected"}
                    </span>
                  )}

                  {(item.subscriptionType || item.subscriptionAmount > 0) && (
                    <span className="OrderItemDetails-item-config-badge">
                      🔄 {item.subscriptionType || "No Subscription"}
                    </span>
                  )}

                  <span className="OrderItemDetails-item-config-badge">
                    Quantity: {item?.quantity}
                  </span>
                </div>

                <p className="OrderItemDetails-price">₹{item?.totalPrice}</p>
              </div>

              <div className="OrderItemDetails-imageContainer">
                <img
                  src={
                    device?.image?.[0] ||
                    "https://storage.googleapis.com/way4track-application/device_media/1763618936164-image_1763618896161_328.png"
                  }
                  alt={item.name}
                  className="OrderItemDetails-image"
                />
              </div>
            </div>

            <div className="OrderItemDetails-statusTimeline">
              <div className="order-item-action-buttons">
                <OrderTimeline order={item} />
                {/* {canCancel && (
                  <div className="action-section">
                    <button
                      className="action-btn cancel-btn"
                      onClick={() => setShowCancelReason(true)}
                      disabled={isLoading}
                    >
                      {isLoading ? "Processing..." : "Cancel Order"}
                    </button>

                    {showCancelReason && (
                      <div className="reason-form">
                        <label>
                          Reason for cancellation:
                          <select
                            value={cancelReason}
                            onChange={(e) => setCancelReason(e.target.value)}
                            required
                          >
                            <option value="">-- Select a reason --</option>
                            <option value="Changed my mind">Changed my mind</option>
                            <option value="Found a better price">Found a better price</option>
                            <option value="Ordered by mistake">Ordered by mistake</option>
                            <option value="Item not required">Item not required</option>
                            <option value="Other">Other</option>
                          </select>
                        </label>
                        <div className="form-actions">
                          <button
                            className="action-btn submit-btn"
                            onClick={() => handleUpdate("cancel", { reason: cancelReason })}
                            disabled={!cancelReason || isLoading}
                          >
                            {isLoading ? "Submitting..." : "Submit Cancellation"}
                          </button>
                          <button
                            className="action-btn secondary-btn"
                            onClick={() => setShowCancelReason(false)}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                )} */}

                {canCancel && (
                  <div className="action-section">
                    <button
                      className="action-btn cancel-btn"
                      onClick={() => setShowCancelReason(true)}
                      disabled={isLoading}
                    >
                      {isLoading ? "Processing..." : "Cancel Order"}
                    </button>

                    {showCancelReason && (
                      <div className="reason-form">
                        {/* ⚠️ Dynamic Shipping Disclaimer */}
                        {/* <div className="shipping-warning-card">
                          <div className="shipping-warning-header">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="warning-icon"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 9v2m0 4h.01M12 5.5a7 7 0 110 13.99A7 7 0 0112 5.5z"
                              />
                            </svg>
                            <span>Cancellation Alert</span>
                          </div>

                          <p className="shipping-warning-text">
                            Cancelling this item may affect your shipping charges.
                          </p>

                          <div className="refund-summary">

                            <p>
                              <strong>Item total:</strong> ₹{item.totalPrice}
                            </p>
                            {item.couponShare > 0 && (
                              <p>
                                <strong>Coupon applied:</strong> -₹{item.couponShare}
                              </p>
                            )}

                            {order.totalQuantity - item.quantity < 2 || order.totalAmount - item.totalPrice < 3000 ? (
                              <>
                                <p>
                                  <strong>Shipping charge applied:</strong> ₹250
                                </p>
                                <p>
                                  <strong>Refund amount:</strong> ₹
                                  {Math.max(0, item.totalPrice - 250)}
                                </p>
                                <p className="shipping-note">
                                  Refund adjusted for shipping charge due to order falling below minimum 2 items or ₹3000.
                                </p>
                              </>
                            ) : (
                              <p>
                                <strong>Refund amount:</strong> ₹{Math.max(0, item.totalPrice - item.couponShare)} (Full refund, free shipping remains)
                              </p>
                            )}
                          </div>
                        </div> */}

                        {(() => {
                          const preview = getCancellationPreview();

                          if (!preview) return null;

                          return (
                            <div
                              className={`shipping-warning-card ${preview.type}`}
                            >
                              {/* HEADER */}
                              <div className="shipping-warning-header">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="warning-icon"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke={getIcon(preview.type)}
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M12 9v2m0 4h.01M12 5.5a7 7 0 110 13.99A7 7 0 0112 5.5z"
                                  />
                                </svg>

                                <div className="shipping-warning-title-wrap">
                                  <h4>{preview.title}</h4>
                                  <p>{preview.message}</p>
                                </div>
                              </div>

                              {/* REFUND BREAKDOWN */}
                              <div className="refund-breakdown-card">
                                <div className="refund-section-title">
                                  Price Breakdown
                                </div>

                                {/* PRODUCT */}
                                <div className="refund-row">
                                  <span>Product Total</span>
                                  <strong>
                                    ₹{preview.itemTotal?.toFixed(2)}
                                  </strong>
                                </div>

                                {/* COUPON */}
                                {/* {preview.coupon > 0 && (
                                  <div className="refund-row discount">
                                    <span>Coupon Discount Share</span>
                                    <strong>
                                      - ₹{couponDiscountedAmount.toFixed(2)}
                                    </strong>
                                  </div>
                                )} */}

                                {/* SHIPPING DEDUCTION */}
                                {preview.shippingDeduction > 0 && (
                                  <div className="refund-row deduction">
                                    <span>Shipping Charge Deduction</span>
                                    <strong>
                                      - ₹{preview.shippingDeduction?.toFixed(2)}
                                    </strong>
                                  </div>
                                )}

                                {/* SHIPPING REFUND */}
                                {preview.shippingRefund > 0 && (
                                  <div className="refund-row success">
                                    <span>Shipping Refund</span>
                                    <strong>
                                      + ₹{preview.shippingRefund?.toFixed(2)}
                                    </strong>
                                  </div>
                                )}

                                {/* GATEWAY FEE */}
                                {preview.gatewayDeduction > 0 && (
                                  <div className="refund-row deduction">
                                    <span>
                                      Payment Gateway Fee(Including GST(18%))
                                    </span>
                                    <strong>
                                      - ₹{preview.gatewayDeduction?.toFixed(2)}
                                    </strong>
                                  </div>
                                )}

                                {/* GATEWAY TAX */}
                                {/* {preview.gatewayTaxDeduction > 0 && (
                                  <div className="refund-row deduction">
                                    <span>Gateway GST</span>
                                    <strong>
                                      - ₹{preview.gatewayTaxDeduction?.toFixed(2)}
                                    </strong>
                                  </div>
                                )} */}

                                <div className="refund-divider" />

                                {/* FINAL REFUND */}
                                <div className="refund-row refund-total success-text">
                                  <span>Estimated Refund</span>
                                  <strong>
                                    ₹{preview.refundAmount?.toFixed(2)}
                                  </strong>
                                </div>
                              </div>

                              {/* ORDER STATUS */}
                              {/* <div className="refund-extra-details">

                                <div className="refund-section-title">
                                  Order Status After Cancellation
                                </div>

                                <div className="refund-info-grid">

                                  <div className="refund-info-box">
                                    <span>Remaining Qty</span>
                                    <strong>{preview.remainingQty}</strong>
                                  </div>

                                  <div className="refund-info-box">
                                    <span>Remaining Order Value</span>
                                    <strong>
                                      ₹{preview.remainingAmount?.toFixed(2)}
                                    </strong>
                                  </div>

                                  <div className="refund-info-box">
                                    <span>Free Shipping</span>
                                    <strong
                                      className={
                                        preview.freeShippingEligible
                                          ? "success-text"
                                          : "danger-text"
                                      }
                                    >
                                      {preview.freeShippingEligible
                                        ? "Eligible"
                                        : "Not Eligible"}
                                    </strong>
                                  </div>

                                  <div className="refund-info-box">
                                    <span>Shipment Status</span>
                                    <strong
                                      className={
                                        preview.hasAnyShipmentInOrder
                                          ? "danger-text"
                                          : "success-text"
                                      }
                                    >
                                      {preview.hasAnyShipmentInOrder
                                        ? "Shipment Created"
                                        : "Not Shipped"}
                                    </strong>
                                  </div>

                                </div>
                              </div> */}

                              {/* ALERT NOTES */}
                              <div className="refund-notes-wrapper">
                                {preview.isLastItem && (
                                  <div className="refund-note success">
                                    Cancelling this item will close the entire
                                    order and shipping charges will be refunded.
                                  </div>
                                )}

                                {!preview.freeShippingEligible &&
                                  !preview.isLastItem &&
                                  !preview.hasAnyShipmentInOrder && (
                                    <div className="refund-note warning">
                                      Remaining order no longer satisfies free
                                      shipping conditions (Minimum ₹3000 and 2
                                      quantity required).
                                    </div>
                                  )}

                                {preview.hasAnyShipmentInOrder && (
                                  <div className="refund-note danger">
                                    Shipping charges are non-refundable once
                                    shipment creation starts.
                                  </div>
                                )}

                                {preview.hasShipment && (
                                  <div className="refund-note locked">
                                    This item already has shipment tracking
                                    associated with it and cannot be cancelled.
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })()}

                        <label>
                          Reason for cancellation:
                          <select
                            value={cancelReason}
                            onChange={(e) => setCancelReason(e.target.value)}
                            required
                          >
                            <option value="">-- Select a reason --</option>
                            <option value="Changed my mind">
                              Changed my mind
                            </option>
                            <option value="Found a better price">
                              Found a better price
                            </option>
                            <option value="Ordered by mistake">
                              Ordered by mistake
                            </option>
                            <option value="Item not required">
                              Item not required
                            </option>
                            <option value="Other">Other</option>
                          </select>
                        </label>

                        <div className="form-actions">
                          <button
                            className="action-btn submit-btn"
                            onClick={() =>
                              handleUpdate("cancel", {
                                reason: cancelReason,
                                // Dynamically send shipping adjustment info
                                shippingAdjustment:
                                  order.totalAmount - item.totalPrice < 3000
                                    ? 250
                                    : 0,
                              })
                            }
                            disabled={!cancelReason || isLoading}
                          >
                            {isLoading
                              ? "Submitting..."
                              : "Submit Cancellation"}
                          </button>

                          <button
                            className="action-btn secondary-btn"
                            onClick={() => setShowCancelReason(false)}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {canReplace && (
                  <div className="action-section">

                    <div className="replacement-balance-card">
                      <span>Available Replacement Quantity</span>
                      <strong>{availableReplacementQty}</strong>
                    </div>

                    <button
                      className="action-btn replace-btn"
                      onClick={() => setShowReplaceForm(true)}
                      disabled={isLoading}
                    >
                      {isLoading ? "Processing..." : "Request Replace"}
                    </button>



                    {showReplaceForm && (
                      <div className="reason-form">

                        <label className="replacement-qty-label">
                          Replacement Quantity
                        </label>

                        <input
                          type="number"
                          min="1"
                          max={availableReplacementQty}
                          value={replacementQty}
                          className="replacement-qty-input"
                          onChange={(e) => {
                            const value = Number(e.target.value);

                            if (!value || value < 1) {
                              setReplacementQty(1);
                            } else if (value > availableReplacementQty) {
                              setReplacementQty(availableReplacementQty);
                            } else {
                              setReplacementQty(value);
                            }
                          }}
                        />

                        <div className="replacement-qty-info">
                          <span>Available for replacement</span>
                          <strong>{availableReplacementQty}</strong>
                        </div>
                        <label>
                          Reason for replacement:
                          <select
                            value={replaceReason}
                            onChange={(e) => setReplaceReason(e.target.value)}
                            required
                          >
                            <option value="">-- Select a reason --</option>
                            <option value="Defective item">
                              Defective item
                            </option>
                            <option value="Item damaged during delivery">
                              Item damaged during delivery
                            </option>
                            <option value="Wrong item received">
                              Wrong item received
                            </option>
                            <option value="Other">Other</option>
                          </select>
                        </label>

                        <label>
                          Additional Description:
                          <textarea
                            value={replaceDescription}
                            onChange={(e) =>
                              setReplaceDescription(e.target.value)
                            }
                            placeholder="Please provide additional details..."
                            rows="3"
                          />
                        </label>

                        <label>
                          Upload Damage Images:
                          <input
                            type="file"
                            accept="image/*"
                            multiple
                            onChange={handleImageUpload}
                            className="file-input"
                          />
                        </label>

                        {/* ✅ Preview Section */}
                        {previewUrls.length > 0 && (
                          <div className="image-preview-container">
                            {previewUrls.map((url, index) => (
                              <div key={index} className="preview-box">
                                <img
                                  src={url}
                                  alt="preview"
                                  className="preview-img"
                                />
                              </div>
                            ))}
                          </div>
                        )}

                        <div className="form-actions">
                          <button
                            className="action-btn submit-btn"
                            // onClick={() => handleUpdate("replace", {
                            //   reason: replaceReason,
                            //   description: replaceDescription,
                            //   damageImage: uploadedImage,
                            // })}
                            onClick={handleReplacementRequest}
                            disabled={!replaceReason || isLoading}
                          >
                            {isLoading
                              ? "Submitting..."
                              : "Submit Replacement Request"}
                          </button>
                          <button
                            className="action-btn secondary-btn"
                            onClick={() => setShowReplaceForm(false)}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {replacement && (
                  <div className="replacement-status">
                    <h4>Replacement Details</h4>

                    <div className={`status-message ${replacement.status}`}>
                      {getReplacementMessage(replacement.status)}
                    </div>

                    <div className="replacement-qty-summary">
                      <div className="qty-card">
                        <span>Ordered Qty</span>
                        <strong>{orderedQty}</strong>
                      </div>

                      <div className="qty-card">
                        <span>Requested Qty</span>
                        <strong>{requestedReplacementQty}</strong>
                      </div>

                      <div className="qty-card approved">
                        <span>Approved Qty</span>
                        <strong>{approvedReplacementQty}</strong>
                      </div>

                      <div className="qty-card remaining">
                        <span>Remaining Qty</span>
                        <strong>{remainingReplacementQty}</strong>
                      </div>
                    </div>

                    <div className="replacement-details-box">
                      <p>
                        <strong>Reason:</strong> {replacement.reason}
                      </p>

                      {replacement.comment && (
                        <p>
                          <strong>Description:</strong> {replacement.comment}
                        </p>
                      )}

                      {replacement.adminRemark && (
                        <p>
                          <strong>Admin Response:</strong>{" "}
                          {replacement.adminRemark}
                        </p>
                      )}

                      {replacement.pickupDate && (
                        <p>
                          <strong>Pickup Date:</strong>{" "}
                          {formatDate(replacement.pickupDate)}
                        </p>
                      )}

                      <p>
                        <strong>Requested On:</strong>{" "}
                        {formatDate(replacement.createdAt)}
                      </p>
                    </div>

                    {/* ✅ Images Preview */}
                    {replacement.images?.length > 0 && (
                      <div className="replacement-images">
                        <h5>Uploaded Images</h5>
                        <div className="image-preview-container">
                          {replacement.images.map((img, index) => (
                            <div key={index} className="preview-box">
                              <img
                                src={img}
                                alt="replacement-proof"
                                onClick={() => handleDownload(img, index)}
                                className="preview-img"
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* {refundStatus && (
                <div className="refund-status">
                  <h4>Replacement Status</h4>
                  <div className={`status-message ${refundStatus}`}>
                    {getRefundStatusMessage(refundStatus)}
                  </div>
                  {refund?.description && (
                    <p className="refund-note">
                      <strong>Note:</strong> {refund.description}
                    </p>
                  )}
                </div>
              )} */}

              {/* {refunds?.length > 0 && (
                <div className="RefundDetails">
                  <h3>Refund Details</h3>
                  {refunds.map((r) => (
                    r.orderItem.itemStatus === "cancelled" && (
                      <div key={r.id} className="RefundCard">
                        <p><strong>Order Item:</strong> {r.orderItem.orderItemNumber} – {r.orderItem.deviceName}</p>
                        <p><strong>Status:</strong> {r.orderItem.itemStatus.toUpperCase()}</p>
                        <p><strong>Quantity:</strong> {r.orderItem.quantity}</p>

                        <h4>Refund Summary</h4>
                        <p><strong>Refund Amount:</strong> ₹{r.refundAmount}</p>
                        <p><strong>Refund Type:</strong> {r.refundType}</p>
                        <p><strong>Refund Status:</strong> {r.refundStatus.toUpperCase()}</p>
                        <p><strong>Requested At:</strong> {new Date(r.createdAt).toLocaleString()}</p>
                        <p><strong>Processed At:</strong> {new Date(r.processedAt).toLocaleString()}</p>
                        <p><strong>Processed By:</strong> {r.processedBy}</p>
                        <p><strong>Reason:</strong> {r.reason}</p>

                        <h4>Payment & Gateway Info</h4>
                        <p><strong>Gateway Payment ID:</strong> {r.gatewayPaymentId}</p>
                        <p><strong>Gateway Refund ID:</strong> {r.gatewayRefundId}</p>
                        <p><strong>Receipt:</strong> {r.gatewayResponse?.receipt || r.gatewayRefundId}</p>
                        <p><strong>Status:</strong> {r.gatewayResponse?.status || r.refundStatus}</p>

                        <h4>Pricing Breakdown</h4>
                        <p>Price: ₹{r.orderItem.price} × {r.orderItem.quantity} = ₹{r.orderItem.price * r.orderItem.quantity}</p>
                        <p>Discount: ₹{r.orderItem.discount}</p>
                        <p>Taxes: ₹{r.orderItem.totalTaxAmount}</p>
                        <p>Shipping: ₹{r.orderItem.shippingAmount}</p>
                        <p><strong>Total Price:</strong> ₹{r.orderItem.totalPrice}</p>
                        <p><strong>Coupon Discount:</strong> ₹{r.orderItem.couponDiscount}</p>
                      </div>
                    )
                  ))}
                </div>
              )} */}

              {/* {refund.length > 0 && ( */}
              <RefundDetailsCard refund={refund} />
              {/* )} */}
            </div>

            <div className="OrderItemDetails-reviewSection">
              <div className="rating-section">
                <h4>Rate this product</h4>
                <div className="OrderItemDetails-star-rating">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <button
                      key={star}
                      className={`star ${star <= (hoverRating || rating) ? "filled" : ""}`}
                      onClick={() => handleStarClick(star)}
                      onMouseEnter={() => setHoverRating(star)}
                      onMouseLeave={() => setHoverRating(0)}
                      disabled={isLoading}
                    >
                      ★
                    </button>
                  ))}
                </div>
                <span className="rating-text">
                  {rating > 0
                    ? `You rated ${rating} star${rating > 1 ? "s" : ""}`
                    : "Click to rate"}
                </span>
              </div>

              <button
                className="action-btn review-btn"
                onClick={() => setShowReviewForm(true)}
              >
                Write a Review
              </button>

              {showReviewForm && (
                <div className="modal-overlay">
                  <div className="modal-content">
                    <button
                      className="modal-close"
                      onClick={() => setShowReviewForm(false)}
                    >
                      ×
                    </button>
                    <ProductReviewForm
                      item={item}
                      review={reviews}
                      initialRating={rating}
                      onClose={() => setShowReviewForm(false)}
                    />
                  </div>
                </div>
              )}
            </div>
            {/* </div> */}
          </div>

          <div className="OrderItemDetails-right">
            <div className="sidebar-card">
              <h3>Shipping Address</h3>
              <div className="OrderItemDetails-address-details">
                <h4>{order.deliveryAddress?.name}</h4>
                <p>
                  {[
                    order.deliveryAddress?.addressLineOne,
                    order.deliveryAddress?.addressLineTwo,
                    order.deliveryAddress?.city,
                    order.deliveryAddress?.state,
                    order.deliveryAddress?.pincode,
                    order.deliveryAddress?.country,
                  ]
                    .filter(Boolean)
                    .join(", ")}
                </p>

                <p className="phone">
                  <span>Phone:</span> {order.deliveryAddress?.phoneNumber}
                </p>
              </div>
            </div>

            <div className="sidebar-card">
              <h3>Billing Address</h3>
              <div className="OrderItemDetails-address-details">
                <h4>{order.billingAddress?.name}</h4>
                <p>
                  {[
                    order.billingAddress?.addressLineOne,
                    order.billingAddress?.addressLineTwo,
                    order.billingAddress?.city,
                    order.billingAddress?.state,
                    order.billingAddress?.pincode,
                    order.billingAddress?.country,
                  ]
                    .filter(Boolean)
                    .join(", ")}
                </p>

                <p className="phone">
                  <span>Phone:</span> {order.billingAddress?.phoneNumber}
                </p>
              </div>
            </div>

            <div className="sidebar-card price-card">
              <h3>Price Details</h3>
              <div className="price-details">
                <div className="price-row">
                  <span>Unit Price</span>
                  <span>₹{item.unitPrice.toFixed(2)}</span>
                  {/* <span>₹{unitPrice(item?.price)}</span> */}
                </div>

                <div className="price-row discount">
                  <span>Discount</span>
                  <span>{item?.discount}%</span>
                </div>

                <div className="price-row">
                  <span>Discounted Price</span>
                  {/* <span>₹{discountedPrice(item?.finalPrice)}</span> */}
                  <span>₹{item?.discountedAmount.toFixed(2)}</span>
                </div>

                {item.relayAmount > 0 && (
                  <div className="price-row addon">
                    <span>Relay Module Charges</span>
                    <span>+ ₹{item.relayAmount}</span>
                  </div>
                )}

                {item.networkAmount > 0 && (
                  <div className="price-row addon">
                    <span>Network Plan Charges ({item.networkType})</span>
                    <span>+ ₹{item.networkAmount}</span>
                  </div>
                )}

                {item.subscriptionAmount > 0 && (
                  <div className="price-row addon">
                    <span>Subscription Charges ({item.subscriptionType})</span>
                    <span>+ ₹{item.subscriptionAmount}</span>
                  </div>
                )}

                <div className="divider"  ></div>

                <div className="price-row subtotal">
                  <span>Per Unit Total</span>
                  <span>₹{item?.itemTotal.toFixed(2)}</span>
                </div>


                <div className="price-row">
                  <span>Quantity</span>
                  <span className="quantity-badge">{item.quantity}</span>
                </div>

                <div className="divider"></div>

                <div className="price-row subtotal">
                  <span>Item Subtotal</span>
                  {/* <span>
                    ₹{(Math.floor(item.finalPrice * item.quantity * 100) / 100).toFixed(2)}
                  </span> */}
                  {/* <span>{item.totalPrice}</span> */}
                  <span>₹{finalItemSubtotal.toFixed(2)}</span>
                </div>


                {/* {item.totalTaxAmount > 0 &&
                  <div className="price-row tax">
                    <span>GST</span>
                    <span>₹{item.totalTaxAmount}</span>
                  </div>
                } */}

                {Number(item?.couponDiscount) > 0 && (
                  <div className="price-row discount">
                    <span>Promotional Discount</span>
                    {/* <span>₹{item?.couponDiscount}</span> */}
                    <span>- ₹{couponDiscountedAmount.toFixed(2)}</span>
                  </div>
                )}

                <div className="divider"></div>

                <div className="price-row final-total">
                  <span>Item Total</span>
                  <span>₹{item.totalPrice}</span>
                </div>

                <p className="product-overview-tax-text">
                  Inclusive of all taxes
                </p>

                {/* {item?.itemStatus === "shipped" && ( */}
                {invoiceUrl && (
                  <div
                    className="sidebar-card invoice-card"
                    onClick={() =>
                      handleDownloadInvoice(
                        item?.shipmentItems?.[0]?.shipment?.invoice?.pdfUrl,
                      )
                    }
                  >
                    <div className="card-icon">
                      <LiaFileInvoiceSolid size={22} />
                    </div>

                    <div className="card-content">
                      <h4>Download Invoice</h4>
                    </div>

                    <IoMdArrowDropright size={20} className="arrow-icon" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderItemDetails;

// else if (actionType === "replace") {
//   const refundFormData = new FormData();
//   refundFormData.append("companyCode", companyCode);
//   refundFormData.append("unitCode", unitCode);
//   refundFormData.append("clientId", clientDbId);
//   refundFormData.append("orderId", order.id);
//   refundFormData.append("deviceId", item.deviceId);
//   refundFormData.append("OrderItemStatus", OrderItemStatus.request_raised);
//   refundFormData.append("refundStatus", RefundStatus.PENDING);
//   refundFormData.append(
//     "description",
//     replaceDescription || "User action"
//   );
//   refundFormData.append("name", order.name);
//   refundFormData.append("reason", replaceReason);
//   refundFormData.append("dateOfRequest", new Date().toISOString());
//   refundFormData.append("dateOfReplace", new Date().toISOString());

//   const refundResponse = await ApiService.post(
//     "/Refund/handleRefundDetails",
//     refundFormData,
//     {
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//     }
//   );

//   if (refundResponse.status) {
//     toast.success("Replacement request submitted successfully.");
//   } else {
//     toast.error("Failed to submit replacement request.");
//     return;
//   }

//   const createOrderPayload = {
//     ...basePayload,
//     id: order.id,
//     OrderItemStatus: OrderItemStatus.request_raised,
//     description: replaceDescription || "Replacement initiated",
//   };

//   const createOrderResponse = await ApiService.post(
//     "/order/handleCreateOrder",
//     createOrderPayload
//   );

//   if (createOrderResponse.status) {
//     toast.success("Order updated successfully for replacement.");
//     // setTimeout(() => window.location.reload(), 1500);
//     setTimeout(() => {
//       // navigate(-1);
//       navigate("/my-profile?tab=orders");
//     }, 1500);
//   } else {
//     toast.error("Failed to update the order.");
//   }
// }
